<template>
  <div class="card my-3 px-3 py-3">
    <h5 style="color: #000">{{ title }}</h5>
    <apexchart type="pie" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ['title', 'values', 'categories'],
  data: function() {
    return {
      chartOptions: {
        chart: {
          id: "piechart"
        },
        dataLabels: {
          dropShadow: {
            enabled: false
          },
          formatter: function (val, opts) {
            return Math.trunc(val) + '%'
          },
        },
        theme: {
          palette: "palette6"
        },
        labels: this.categories
      },
      series: this.values
    };
  }
};
</script>